import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from '../../context/I18nContext';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiHome, FiBox, FiShoppingCart, FiSettings, FiLogOut } = FiIcons;

const NavItem = ({ to, icon, label }) => (
  <NavLink
    to={to}
    end={to === "/dashboard"}
    className={({ isActive }) =>
      `flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
        isActive
          ? 'bg-zinc-100 text-zinc-900'
          : 'text-zinc-500 hover:text-zinc-900 hover:bg-zinc-50'
      }`
    }
  >
    <SafeIcon icon={icon} className="w-4 h-4" />
    {label}
  </NavLink>
);

export const DashboardSidebar = () => {
  const { t } = useTranslation();

  return (
    <aside className="w-64 border-r border-zinc-200 bg-white h-screen sticky top-0 flex flex-col hidden md:flex">
      <div className="h-16 flex items-center px-6 border-b border-zinc-100">
        <div className="text-xl font-bold tracking-tight text-zinc-900 flex items-center gap-2">
          <div className="w-8 h-8 bg-zinc-900 rounded-lg flex items-center justify-center">
            <span className="text-white text-lg leading-none mt-[-2px]">f</span>
          </div>
          Foodrolla
        </div>
      </div>

      <nav className="flex-1 px-3 py-6 space-y-1">
        <NavItem to="/dashboard" icon={FiHome} label={t('dashboard.orders')} />
        <NavItem to="/dashboard/products" icon={FiBox} label={t('dashboard.products')} />
        <NavItem to="/dashboard/orders" icon={FiShoppingCart} label={t('dashboard.incomingOrders')} />
        <NavItem to="/dashboard/settings" icon={FiSettings} label={t('dashboard.settings')} />
      </nav>

      <div className="p-4 border-t border-zinc-100">
        <NavLink
          to="/"
          className="flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium text-zinc-500 hover:text-zinc-900 hover:bg-zinc-50 transition-colors"
        >
          <SafeIcon icon={FiLogOut} className="w-4 h-4" />
          {t('nav.logout')}
        </NavLink>
      </div>
    </aside>
  );
};